export enum enumOrganizationSize {
  INDIVIDUAL_SMALL = 1,
  BUSINESS_SMALL = 2,
  INDIVIDUAL_MEDIUM = 3,
  BUSINESS_MEDIUM = 4,
  INDIVIDUAL_LARGE = 5,
  BUSINESS_LARGE = 6,
}
